// extracted by mini-css-extract-plugin
module.exports = {"Submit":"AccountCreate_Submit__1A9nq","SubmitError":"AccountCreate_SubmitError__qaw0K"};